import React from "react";
import "./footer.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUp, faFire, faShuttleSpace } from "@fortawesome/free-solid-svg-icons";

function Footer() {
  return (
    <div>
      <div className="footer">Made 🔥 By Prince Kumar © 2023.</div>
      <div className="progress">
        <h3>( Website Only for Desktop Mode )  We in progress🧑‍💻 </h3>
        <div class="loader">
              <div class="dot"></div>
              <div class="dot"></div>
              <div class="dot"></div>
              {/* <div class="dot"></div> */}
            </div>
      </div>
      <div className="UpArrow">
        <a href="#">
          {/* <FontAwesomeIcon icon={faArrowUp} size="2xl" /> */}
          <FontAwesomeIcon icon={faShuttleSpace} rotation={270} />
        </a>
        {/* <a href="" className="fire">

          <FontAwesomeIcon icon={faFire} flip="vertical" />
        </a> */}
      </div>
    </div>
  );
}

export default Footer;
